import { render, staticRenderFns } from "./SupportTicketForm.vue?vue&type=template&id=99f52344&scoped=true&"
import script from "./SupportTicketForm.vue?vue&type=script&lang=js&"
export * from "./SupportTicketForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketForm.vue?vue&type=style&index=0&id=99f52344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f52344",
  null
  
)

export default component.exports